module.exports = __webpack_public_path__ + "img/LOGOREUNIBOX.d5adfcbc.png";